import { Method, send } from './MyHttp';

/**
 * 리스트
 */
export const GetList = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, '/push', paramsT, success, fail);
};

export const GetListRead = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, '/push/read', paramsT, success, fail);
};

export const Count = (success, fail) => {
    send(Method.GET, '/push/count', {}, success, fail);
};


/**
 * push 생성 (알람 발생 시 호출)
 * @param {string} device_sn
 * @param {string} type
 */
export const CreatePush = (device_sn, type, success, fail) => {
    send(
        Method.GET,
        `/push/${device_sn}/${type}`,
        {},
        success,
        fail
    );
};